import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const AdTypes = {
  List: lazyNamed(() => import('./containers/AdTypesList/index.tsx'), 'AdTypesList'),
  Edit: lazyNamed(() => import('./containers/AdTypeEdit/index.tsx'), 'AdTypeFormPage'),
  History: lazyNamed(() => import('./containers/AdTypeHistory.tsx'), 'AdTypeHistory'),
};
